import { useEffect, useState } from "react";
import Orders from "./Orders";
import ChevronLeft from "../icons/ChevronLeft";
import ChevronRight from "../icons/ChevronRight";

function Sidebar() {
	const [expanded, setExpanded] = useState(
		localStorage.getItem("tracking-sidebar-expanded") == "true"
	);

	useEffect(() => {
		setTimeout(emitResizeEvent, 300);
	}, [expanded]);

	const emitResizeEvent = () => {
		window.dispatchEvent(new Event("resize"));
	};

	return (
		<div id="sidebar" className={expanded ? "expanded" : ""}>
			<button
				className="sidebar-button"
				onClick={() => {
					setExpanded(!expanded);
					localStorage.setItem("tracking-sidebar-expanded", !expanded);
				}}
			>
				{expanded ? <ChevronRight /> : <ChevronLeft />}
			</button>

			<Orders status="awaiting" />
			<Orders status="delivering" />
			<Orders status="filled" />
		</div>
	);
}

export default Sidebar;
